import { api } from "../../ConsumeApiController";
import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";


/**
 * =========================================================================
 * MERCHANT TICKET CONTROLLER (FRONTEND)
 * =========================================================================
 * Archivo encargado de la comunicación con la API para la Taquilla (POS)
 */

/**
 * Obtiene los detalles del evento y sus secciones/precios.
 * Método: GET
 * @param {number|string} eventId - El ID del evento
 * @returns {Promise<Object>} - Respuesta con { success, data: { event, sections }, message }
 */
export const GetBoxOfficeEventDetails = async (eventId) => {
    try {
        // Ajusta la ruta base según cómo esté configurado tu wrapper api.get
        //const response = await api.get(`/api/merchant/events/${eventId}/box-office-details`);
        const response = await api.get(CompanyRoutes.Events.GetEvent(eventId));
        
        // Asumiendo que tu wrapper ya devuelve el JSON parseado
        return response; 
    } catch (error) {
        console.error("Error en GetBoxOfficeEventDetails:", error);
        return { 
            success: false, 
            message: error?.message || 'Error de conexión obteniendo los detalles del evento.' 
        };
    }
}

/**
 * Emite los boletos procesando el carrito, los pagos y el cliente.
 * Método: POST
 * @param {Object} payload - Objeto completo con la orden estructurada
 * @returns {Promise<Object>} - Respuesta con { success, data: { pedido, tickets }, message }
 */
export const IssueTicketsAtBoxOffice = async (payload) => {
    try {
        // Ajusta la ruta base según cómo esté configurado tu wrapper api.post
        const response = await api.post(CompanyRoutes.Events.Tickets.BoxOfficeIssue, payload);
        
        return response;
    } catch (error) {
        console.error("Error en IssueTicketsAtBoxOffice:", error);
        
        // Si tu wrapper extrae los mensajes de error de Laravel (ej. validaciones 422), 
        // puedes mapearlos aquí. Si no, devolvemos el error genérico.
        return { 
            success: false, 
            message: error?.message || 'Error emitiendo los boletos en taquilla.' 
        };
    }
}


/**
 * Obtiene la lista de tickets emitidos para la pestaña de Ventas
 */
export const getEventTickets = async (eventId) => {
    try {
        // Ajusta la ruta base según tu wrapper api.get
        const response = await api.get(CompanyRoutes.Events.Tickets.GetEventTickets(eventId));
        return response; 
    } catch (error) {
        console.error("Error en GetEventTickets:", error);
        return { success: false, message: 'Error cargando la lista de boletos.' };
    }
}

export async function validateTicket(ticketId)
{
    try {
        // Ajusta la ruta base según tu wrapper api.get
        const response = await api.post(CompanyRoutes.Events.Tickets.Validate(ticketId));
        return response; 
    } catch (error) {
        console.error("Error en validateTicket:", error);
        return { success: false, message: 'Error validando el ticket.' };
    }
}

export async function annulTicket(ticketId)
{
    try {
        // Ajusta la ruta base según tu wrapper api.get
        const response = await api.post(CompanyRoutes.Events.Tickets.Annul(ticketId));
        return response; 
    } catch (error) {
        console.error("Error en annulTicket:", error);
        return { success: false, message: 'Error anulando el ticket.' };
    }
}

// Reenviar Correo
export const resendTicketEmail = async (ticketId) => {
    try {
        const response = await api.post(CompanyRoutes.Events.Tickets.ResendEmail(ticketId));
        return response;
    } catch (error) {
        return { success: false, message: 'Error de red al reenviar el correo.' };
    }
}